import { PropsWithChildren } from 'react';
import { I18nextProvider } from 'react-i18next';

type TranslationsProviderProps = PropsWithChildren<{
  readonly i18nInstance: ReturnType<typeof import('i18next').createInstance>;
}>;

export function TranslationsProvider({
  children,
  i18nInstance,
}: TranslationsProviderProps) {
  return <I18nextProvider i18n={i18nInstance}>{children}</I18nextProvider>;
}
